function SvgPlan(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 65 65"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M56.202 17.247a2.256 2.256 0 002.256 2.251h1.768v4.892h-3.378a2.256 2.256 0 00-2.255 2.252 2.255 2.255 0 002.255 2.251h3.378v4.892h-1.768a2.256 2.256 0 00-2.256 2.252 2.256 2.256 0 002.256 2.251h1.768v4.892h-3.378a2.255 2.255 0 00-2.255 2.251 2.256 2.256 0 002.255 2.252h3.378v4.892h-1.768a2.256 2.256 0 00-2.256 2.251 2.256 2.256 0 002.256 2.252h1.768v3.003H7.704L60.226 7.684v7.312h-1.768a2.256 2.256 0 00-2.256 2.251M63.345.172a2.26 2.26 0 00-2.458.487L.663 60.74a2.239 2.239 0 00-.49 2.455 2.248 2.248 0 002.085 1.39H62.48a2.256 2.256 0 002.256-2.253V2.252c0-.913-.547-1.73-1.392-2.08"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgPlan;
